import http from './http.service';
import { RegisterFieldValueQueryFilter } from '../models/enums';

class DynamicRegisterService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/dynamicRegisters";
    }

    getDetails(registerEntryId, filter) {
        if (filter === RegisterFieldValueQueryFilter.All) {
            return this.$http.get(`${this.baseUrl}/${registerEntryId}/allFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.Active) {
            return this.$http.get(`${this.baseUrl}/${registerEntryId}/activeFieldsDetails`);
        } else if (filter === RegisterFieldValueQueryFilter.ShowInDescription) {
            return this.$http.get(`${this.baseUrl}/${registerEntryId}/showInDesctiptionFieldsDetails`);
        } else {
            return this.$http.get(`${this.baseUrl}/${registerEntryId}/showInDesctiptionFieldsDetails`);
        }
    };
}

export default new DynamicRegisterService();
